import { CultureInfo } from '../culture-info.model';
import { CultureInfoEn } from './en';

/**
 * @ignore
 */
export const CultureInfoEnSK: CultureInfo = {
  name: 'en-SK',
  displayName: 'English (Slovakia)',
  iso3LanguageCode: 'eng',
  iso2LanguageCode: 'en',
  ietfLanguageTag: 'en-SK',
  parent: CultureInfoEn
};
